var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex",on:{"click":_vm.setChecked}},[_c('div',{staticClass:"custom-checkbox"},[_c('div',{class:{ checked: _vm.isChecked },style:(`background-color: ${_vm.selectColor}`)})]),_c('label',{style:(`color: ${_vm.isChecked ? _vm.selectColor : 'white'};
    font-family:${_vm.isChecked ? 'Avenir-Demi' : 'Avenir-Regular'}`)},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }